module.exports = __webpack_public_path__ + "img/pos-x.d1662f3d.png";